import type { StringifyOptions } from 'query-string';
import querystring from 'query-string';

const parse = <T>(query: string, options?: Parameters<typeof querystring.parse>[1]) => {
  return querystring.parse(query, options) as unknown as T;
};

const stringify = <T extends Record<string, unknown>>(data: T, options?: StringifyOptions) => {
  return querystring.stringify(data, options);
};

export default {
  parse,
  stringify,
};
